/**
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";

import Typestextes from "layouts/types-textes";
import TextesReglementaires from "layouts/textes-reglementaires";
import Domaines from "layouts/domaines";
import Notifications from "layouts/notifications";
import Newsletter from "layouts/newsletter";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import Home from "layouts/home";
import ForgotPassword from "layouts/authentication/forgot-password";
import ResetPassword from "layouts/authentication/reset-password";
import Contact from "layouts/contact";
import Documentation from "layouts/documentation";
import PolitiqueConfidentialite from "layouts/politique-confidentialite";
import MentionsLegales from "layouts/mentions-legales";
// @mui icons
import Icon from "@mui/material/Icon";
import Utilisateurs from "layouts/utilisateurs";
import BaseDocumentaire from "layouts/base-documentaire";
import Institutions from "layouts/institutions";
import AnalyseTexte from "layouts/analyse-texte";
import GestionRisques from "layouts/gestion-risques";
import ProceduresInternes from "layouts/procedures-internes";
import ControleAudit from "layouts/controle";
import SuiviRecommandations from "layouts/suivi-recommandations";
// Routes privées (pour les utilisateurs connectés)
export const privateRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Types de texte",
    key: "types-textes",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/types-textes",
    component: <Typestextes />,
    roles: ["ADMIN_GLOBAL"],
  },
  {
    type: "collapse",
    name: "Domaines",
    key: "domaines",
    icon: <Icon fontSize="small">domain</Icon>,
    route: "/domaines",
    component: <Domaines />,
    roles: ["ADMIN_GLOBAL"],
  },
  {
    type: "collapse",
    name: "Textes réglementaires",
    key: "textes-reglementaires",
    icon: <Icon fontSize="small">gavel</Icon>,
    route: "/textes-reglementaires",
    component: <TextesReglementaires />,
    roles: ["ADMIN_GLOBAL"],
  },
  {
    type: "collapse",
    name: "Textes réglementaires",
    key: "base-documentaire",
    icon: <Icon fontSize="small">library_books</Icon>,
    route: "/base-documentaire",
    component: <BaseDocumentaire />,
    excludeRoles: ["ADMIN_GLOBAL"],
  },
  {
    type: "collapse",
    name: "Procédures internes",
    key: "procedures-internes",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/procedures-internes",
    component: <ProceduresInternes />,
    roles: ["ADMIN_INSTITUTION", "GESTIONNAIRE", "ADMIN_GLOBAL", "UTILISATEUR"],
  },
  {
    type: "collapse",
    name: "Gestion des Risques",
    key: "gestion-risques",
    icon: <Icon fontSize="small">security</Icon>,
    route: "/gestion-risques",
    component: <GestionRisques />,
    roles: ["ADMIN_INSTITUTION", "GESTIONNAIRE", "ADMIN_GLOBAL"],
  },
  {
    type: "collapse",
    name: "Contrôle & Audit",
    key: "controle",
    icon: <Icon fontSize="small">fact_check</Icon>,
    route: "/controle",
    component: <ControleAudit />,
    roles: ["ADMIN_GLOBAL", "ADMIN_INSTITUTION", "GESTIONNAIRE", "CONTROLEUR", "UTILISATEUR"],
  },
  {
    type: "collapse",
    name: "Suivi des recommandations",
    key: "suivi-recommandations",
    icon: <Icon fontSize="small">track_changes</Icon>,
    route: "/suivi-recommandations",
    component: <SuiviRecommandations />,
    roles: ["ADMIN_GLOBAL", "ADMIN_INSTITUTION", "GESTIONNAIRE", "CONTROLEUR", "UTILISATEUR"],
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    type: "collapse",
    name: "Utilisateurs",
    key: "utilisateurs",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/utilisateurs",
    component: <Utilisateurs />,
    roles: ["ADMIN_GLOBAL", "ADMIN_INSTITUTION"],
  },
  {
    type: "collapse",
    name: "Institutions",
    key: "institutions",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/institutions",
    component: <Institutions />,
    roles: ["ADMIN_GLOBAL"],
  },
  {
    type: "collapse",
    name: "Newsletter",
    key: "newsletter",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/newsletter",
    component: <Newsletter />,
    roles: ["ADMIN_GLOBAL"],
  },
  {
    type: "route",
    name: "Profil",
    key: "profil",
    route: "/profil",
    component: <Profile />,
  },
  {
    type: "route",
    name: "Analyse Texte",
    key: "analyse-texte",
    route: "/analyse-texte/:texteId",
    component: <AnalyseTexte />,
  },
];

// Routes publiques (sans authentification requise)
export const publicRoutes = [
  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/home",
    component: <Home />,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Mot de passé oublié",
    key: "forgot-password",
    icon: <Icon fontSize="small">Mot de passe oublié</Icon>,
    route: "/authentication/forgot-password",
    component: <ForgotPassword />,
  },
  {
    type: "collapse",
    name: "Réinitialisation mot de passe",
    key: "reset-password",
    icon: <Icon fontSize="small">Réinitialisation mot de passe</Icon>,
    route: "/authentication/reset-password",
    component: <ResetPassword />,
  },
  {
    type: "collapse",
    name: "Contact",
    key: "contact",
    icon: <Icon fontSize="small">contact_support</Icon>,
    route: "/contact",
    component: <Contact />,
  },
  {
    type: "collapse",
    name: "Documentation",
    key: "documentation",
    icon: <Icon fontSize="small">menu_book</Icon>,
    route: "/documentation",
    component: <Documentation />,
  },
  {
    type: "collapse",
    name: "Politique de confidentialité",
    key: "politique-confidentialite",
    icon: <Icon fontSize="small">security</Icon>,
    route: "/politique-confidentialite",
    component: <PolitiqueConfidentialite />,
  },
  {
    type: "collapse",
    name: "Mentions légales",
    key: "mentions-legales",
    icon: <Icon fontSize="small">gavel</Icon>,
    route: "/mentions-legales",
    component: <MentionsLegales />,
  },
];

export default { privateRoutes, publicRoutes };
